module.exports = __webpack_public_path__ + "img/presupuesto.0dea9de2.png";